import { useContext } from 'react';
import AuthContext from 'external/domains/auth/passwordless/components/Provider/context';
function useAuth() {
    const context = useContext(AuthContext);
    return context;
}
export default useAuth;
